export function hasNavigator() {
    return typeof navigator !== 'undefined';
}
export function hasDocument() {
    return typeof document !== 'undefined';
}
export function hasLocalStorage() {
    try {
        return typeof localStorage !== 'undefined';
    }
    catch (error) {
        return false;
    }
}
export function hasSessionStorage() {
    try {
        return typeof sessionStorage !== 'undefined';
    }
    catch (error) {
        return false;
    }
}
export function hasCookieStorage() {
    return Boolean(hasNavigator() && navigator.cookieEnabled);
}
